import { render, staticRenderFns } from "./templateFieldsPreview.vue?vue&type=template&id=2b215861&scoped=true"
import script from "./templateFieldsPreview.vue?vue&type=script&lang=js"
export * from "./templateFieldsPreview.vue?vue&type=script&lang=js"
import style0 from "./templateFieldsPreview.vue?vue&type=style&index=0&id=2b215861&prod&lang=scss&scoped=true"
import style1 from "./templateFieldsPreview.vue?vue&type=style&index=1&id=2b215861&prod&lang=scss&scoped=true"
import style2 from "./templateFieldsPreview.vue?vue&type=style&index=2&id=2b215861&prod&scoped=true&lang=css"
import style3 from "./templateFieldsPreview.vue?vue&type=style&index=3&id=2b215861&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b215861",
  null
  
)

export default component.exports